import React, { useMemo, useState } from "react";
import ReactTableForWeekstaten from "Components/ReactTableForWeekstaten";
import { BsCheckCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import TextLimit from 'Api/TextLimit';
import { Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useContractTypes, useSaveOrUpdate } from "Api/Coordinator/Verzoeken/VervangerZoeken";


const Records = ({ data, subsId, dayId, iCommunityId, showLoader, setShowLoader, pageNumber, setPageNumber, totalPageCount, pageSizeCount, setPageSizeCount, searchHandler, sortParams, handleSorting,count }) => {
    const [selectedContractType, setSelectedContractType] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUserName, setSelectedUserName] = useState('');
    const navigate = useNavigate();
    
    const {
        trigger: saveOrUpdate,
        isMutating,
    } = useSaveOrUpdate();

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const { data: contractResponse } = useContractTypes(
        iCommunityId,
        modalOpen && selectedUserId
    );

    const contractList =
        contractResponse?.data?.data || [];

    const handleNavigate = (iAdminId, iContractId) => {
        
        navigate(`/verzoeken/planscreen/${subsId}/${dayId}/${iContractId}/gebruikers/${iAdminId}`);
       
    };

    const handleSave = () => {
        if (!selectedContractType) {
            alert("Please select a contract type.");
            return;
        }
        const dataToSend = {
            iAdminId: Number(selectedUserId),
            iCommunityId: Number(iCommunityId),
            iContractId: Number(selectedContractType),
        };

        saveOrUpdate({
            method: "post",
            data: dataToSend,
        })
            .then((response) => {
                if (response.status === 200) {
                    toggleModal();
                    handleNavigate(selectedUserId, selectedContractType);
                }
                else {
                    console.error("Failed to update admin community:");
                }

            }).catch(error => {
                console.error("Error saving/updating admin community:", error);
            });
    };

    const columns = useMemo(() => [
        {
            header: () => (
                <div onClick={() => handleSorting('vFirstName')}>
                    <span>Naam</span>  {sortParams.key === 'vFirstName' && (sortParams.order === 'asc' ? '🔼' : sortParams.order === 'desc' ? '🔽' : '')}
                </div>
            ),
            accessorKey: 'fullname',
            enableSorting: false,
            cell: value => (
                window.innerWidth > 1250
                    ? TextLimit.AfwezigeLimitOptionOne(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
                    : TextLimit.AfwezigeLimitOptionTwo(value.row.original.vFirstName, value.row.original.vMiddleName, value.row.original.vLastName)
            ),
        },
        {
            header: () => (
                <div onClick={() => handleSorting('vCity')}>
                    <span>Plaats</span> {sortParams.key === 'vCity' && (sortParams.order === 'asc' ? '🔼' : sortParams.order === 'desc' ? '🔽' : '')}
                </div>
            ),
            accessorKey: 'vCity',
            enableSorting: false,
            cell: ({ row }) => row.original.vCity || 'Niet beschikbaar',
        },
        {
            header: () => (
                <div onClick={() => handleSorting('dBirthDate')}>
                    <span>Geboortedatum</span> {sortParams.key === 'dBirthDate' && (sortParams.order === 'asc' ? '🔼' : sortParams.order === 'desc' ? '🔽' : '')}
                </div>
            ),
            accessorKey: 'dBirthDate',
            enableSorting: false,
            cell: ({ row }) => {
                const birthDate = row.getValue('dBirthDate');
                return birthDate && birthDate !== 'Invalid Date' ? birthDate : '';
            }
        },
        {
            header: () => (
                <div onClick={() => handleSorting('iAdminId')}>
                    <span>Clooser-id</span> {sortParams.key === 'iAdminId' && (sortParams.order === 'asc' ? '🔼' : sortParams.order === 'desc' ? '🔽' : '')}
                </div>
            ),
            accessorKey: 'iAdminId',
            enableSorting: false,
            cell: ({ row }) => row.original.iAdminId || 'Geen ID',
        },
        {
            header: () => 'V',
            accessorKey: 'vRole',
            enableSorting: false,
            cell: ({ row }) => {
                const role = row.original.vRole;
                if (role && role.includes("vervanger")) {
                    return (
                        <BsCheckCircle
                            color="#39A825"
                            fontSize={"18px"}
                            onClick={() => handleNavigate(row.original.iAdminId, row.original.iContractId)}
                        />
                    );
                }
                return "";
            }
        }
    ], [sortParams]);

    const handleRowClick = (row) => {
        const role = row.original.vRole;

        if (role && role.includes("vervanger")) {
            handleNavigate(row.original.iAdminId, row.original.iContractId);
        } else {
            setSelectedUserId(row.original.iAdminId);
            setSelectedUserName(`${row.original.vFirstName} ${row.original.vLastName}`);
            setSelectedContractType("");
            toggleModal();
        }
    };
    const userTablePageSize = (val) => {
        setPageNumber(1);
        setShowLoader(true);
        setPageSizeCount(val);
    }

    const paginate = (val) => {
        setShowLoader(true);
        setPageNumber(val);
    }

    return (
        <>
            <Card className="main-card mb-3">
                <CardBody className="p-3 table-responsive">
                    <ReactTableForWeekstaten
                        data={data}
                        columns={columns}
                        tableClassName="mb-0 table table-sm table-hover table-borderless"
                        filters={{ search: true, pagination: true, sorting: false }}
                        totalPageCount={totalPageCount}
                        userTablePageSize={userTablePageSize}
                        paginate={paginate}
                        pageNumber={pageNumber}
                        setPageNumber={setPageNumber}
                        pageSizeCount={pageSizeCount}
                        showLoader={showLoader}
                        searchHandler={searchHandler}
                        onRowClick={handleRowClick}
                        count={count}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={modalOpen} toggle={toggleModal} className="modal-centered contract-type-modal feedback-modal-style link-form vervanger-zoeken-modal">
                <ModalHeader toggle={toggleModal} className='px-3 mt-4'>Selecteer contracttype</ModalHeader>
                <ModalBody className='text-center mt-4 mb-4'>
                    <p className="contracttype-Modal">
                        {selectedUserName} heeft geen rol als vervanger
                    </p>
                    <label className="mb-3 d-block">Selecteer het gewenste contracttype</label>
                    <select
                        value={selectedContractType}
                        className="select"
                        onChange={(e) => setSelectedContractType(e.target.value)}
                    >
                        <option value="">Selecteer...</option>
                        {contractList?.length > 0 ? (
                            contractList?.map((type) => (
                                <option key={type.iContractTypeId} value={type.iContractTypeId}>
                                    {type.vContractTypeName}
                                </option>
                            ))
                        ) : (
                            <option disabled>Geen contracttypes beschikbaar</option>
                        )}
                    </select>
                </ModalBody>
                <ModalFooter className='justify-content-center pt-3'>
                    <Button className="btn-color-style opslaan-btn" size="sm" outline color="primary" type="button" onClick={handleSave}
                    >
                        Toepassen
                    </Button>
                    <Button className="btn-color-style opslaan-btn" size="sm" outline color="primary" type="button" onClick={() => toggleModal()}>
                        Annuleren
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Records;
